import React from 'react';
import { Flex } from '@chakra-ui/react';
import AddressSection from '../../../components/AddressSection/AddressSection.tsx';
import { overviewContainerStyles } from '../../../styles/ts/overviewStyles.ts';
import type { IAddress } from '../../../interfaces';

type OrganisationDetailsSectionProps = {
  title: string;
  nameLabel: string;
  name: string;
  address: IAddress;
  canEdit: boolean;
  onEdit: () => void;
};

const OrganisationDetailsSection: React.FC<OrganisationDetailsSectionProps> = ({
  title,
  nameLabel,
  name,
  address,
  canEdit,
  onEdit,
}) => {
  return (
    <Flex sx={overviewContainerStyles}>
      <AddressSection
        title={title}
        name={name}
        address={address}
        canEdit={canEdit}
        onEdit={onEdit}
        nameLabel={nameLabel}
        editButtonTestId="organisation-master-data-edit-button"
      />
    </Flex>
  );
};

export default OrganisationDetailsSection;

